import { render, staticRenderFns } from "./SVGModalClose.vue?vue&type=template&id=7a92777c&scoped=true&"
import script from "./SVGModalClose.vue?vue&type=script&lang=js&"
export * from "./SVGModalClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a92777c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a92777c')) {
      api.createRecord('7a92777c', component.options)
    } else {
      api.reload('7a92777c', component.options)
    }
    module.hot.accept("./SVGModalClose.vue?vue&type=template&id=7a92777c&scoped=true&", function () {
      api.rerender('7a92777c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGModalClose.vue"
export default component.exports